import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getBalancerMetricsRequest: ['payload'],
  getBalancerMetricsSuccess: ['payload'],

  balancerMetricsFetchingReset: null,
  logoutSuccess: null,
})

export const BalancerMetricsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  metrics: [],
})

/* ------------- Reducers ------------- */

const getBalancerMetricsRequest = (state) => state.merge({ fetching: true })
const getBalancerMetricsSuccess = (state, { payload }) => state.merge({ fetching: false, metrics: payload || [] })
const balancerMetricsFetchingReset = (state) => state.merge({ fetching: false })
const logoutSuccess = () => INITIAL_STATE

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_BALANCER_METRICS_REQUEST]: getBalancerMetricsRequest,
  [Types.GET_BALANCER_METRICS_SUCCESS]: getBalancerMetricsSuccess,
  [Types.BALANCER_METRICS_FETCHING_RESET]: balancerMetricsFetchingReset,
  [Types.LOGOUT_SUCCESS]: logoutSuccess,
})
